<template>
  <div class="share-bookshelf-dialog">
    <el-dialog
      :title="languageOption.shareCollection(typeName)"
      width="450px"
      top="calc( 50vh - 150px )"
      custom-class="book-share"
      center
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :handleCancel="handleCancel"
      :append-to-body="true"
    >
      <div class="share-bookshelf-dialog-container">
        <vue-qr :text="qrObj.value" :size="88" :margin="5" />
        <div class="info">{{ languageOption.shareCollectionTip(typeName) }}</div>
        <div class="downloadCode" @click="goDownload">{{ languageOption.downloadQrCode }}</div>
        <p class="generatePos" v-if="qrObj.isShowPoster">
          <span @click="goPoster">{{ languageOption.generatePoster }}</span>
        </p>
        <div class="share-content">
          <div class="share-item">
            <div class="share-input">{{ qrObj.value }}</div>
            <div class="share-btn tag-read" @click="handleCopy" :data-clipboard-text="qrObj.value">{{ languageOption.copyLink }}</div>
          </div>
          <div class="share-item" v-if="inSetShow">
            <div class="share-input">{{ qrObj.iframeUrl }}</div>
            <div class="share-btn tag-read" @click="handleCopy" :data-clipboard-text="qrObj.iframeUrl">{{ languageOption.copyIFrameCode }}</div>
          </div>
        </div>
      </div>
    </el-dialog>
    <Poster ref="posters" :current-lang="language" :qrObj="qrObj" :typeName="typeName"></Poster>
    <QrCodeDownlaod v-if="qrDownload" :qrObj="qrObj" @closeDownload="closeDownload"></QrCodeDownlaod>
  </div>
</template>

<script>
import VueQr from 'vue-qr'
import Clipboard from 'clipboard'
import Poster from '@components/poster'
import compareVipRight from '@components/common/compareVipRight.js'
import QrCodeDownlaod from '@components/books/components/qrCodeDownload.vue'
import '@assets/styles/share.scss'
export default {
  name: 'ShareDialog',
  mixins: [compareVipRight],
  data() {
    return {
      dialogVisible: false,
      qrDownload: false
    }
  },
  props: {
    qrObj: {
      type: Object,
      default: function() {
        return {
          value: window.location.href,
          iframeUrl: '<iframe src="' + window.location.href + '" style="width:100%;height:99.5%"></iframe>'
        }
      }
    },
    typeName: String,
    isInset: Boolean,
    language: {
      default: 0
    }
  },
  components: { VueQr, Poster, QrCodeDownlaod },
  computed: {
    inSetShow() {
      return this.isInset && this.compare({ type: 'boole', key: 'embedWebsite' })
    },
    languageOption() {
      return this.$store.state.config.languageOptions[this.language]
    }
  },
  methods: {
    handleCancel() {
      this.dialogVisible = false
    },
    handleCopy() {
      let clipboard = new Clipboard('.tag-read')
      clipboard.on('success', (e) => {
        this.$message({
          message: this.language === 1 ? 'Success' : '复制成功',
          type: 'success'
        })
        clipboard.destroy()
      })
      clipboard.on('error', (e) => {
        console.log('该浏览器不支持自动复制')
        clipboard.destroy()
      })
    },
    goPoster() {
      this.$refs.posters.dialogVisible = true
      this.dialogVisible = false
    },
    goDownload() {
      this.qrDownload = true
    },
    closeDownload() {
      this.qrDownload = false
    }
  },
  mounted() {
    this.getVipInfo()
  }
}
</script>
<style lang="scss" scoped>
.share-bookshelf-dialog {
  /deep/ .el-dialog__header {
    padding: 0;
    line-height: 40px;
    background: #f4f4f4;
    .el-dialog__title {
      font-size: 16px;
    }
    .el-dialog__headerbtn {
      top: 12px;
    }
  }
  /deep/ .el-dialog__body {
    padding: 0 !important;
  }
}
.share-bookshelf-dialog-container {
  text-align: center;
  padding: 19px 0 27px 0;
  margin: 0 auto;
  .info {
    font-size: 14px;
  }
  .generatePos {
    font-size: 14px;
    font-weight: bold;
    // width: 100px;
    text-align: center;
    span {
      color: #df5813;
      text-decoration: underline;
      cursor: pointer;
    }
  }
  .share-content {
    margin-top: 20px;
    .share-item {
      margin-bottom: 10px;
      .share-input {
        display: inline-block;
        width: 250px;
        height: 40px;
        padding: 0 10px;
        line-height: 40px;
        text-align: left;
        border: 1px solid rgba(151, 151, 151, 1);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        vertical-align: top;
      }
      .share-btn {
        display: inline-block;
        width: 120px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        margin-left: 10px;
        border: 1px solid rgba(223, 88, 19, 1);
        color: rgba(223, 88, 19, 1);
        cursor: pointer;
      }
    }
  }
}
</style>
